/*    
<summary>
  This functional component "AddWorkingDays" allows store to change/delete/add details which are visible to customer.
</summary>
<returns>Returns JSX</returns>
*/
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useStore } from "../../../../contexts/store-provider";
import { formatMessage } from "../../../../translations/format-message";
import AddWorkingDaysForm from "../forms/add-edit-cms-working-days-form";

interface IProps {
  id: number;
  storeId: number;
  submitHandler: (data: any) => void;
  modalClosed: () => void;
}

const AddWorkingDays = (props: IProps) => {
  const { storeCmsStore } = useStore();
  const {
    getWorkingHoursSettingDetail,
    GetStoreCmsWorkingHoursByIdAnonymousService,
    AddCMSWorkingHoursService,
    addUpdateCmsWorkingHoursState,
    UpdateCMSWorkingHoursService,
    resetAddUpdateCMSWorkingHoursState,
    cmsStoreWorkingHoursState
  } = storeCmsStore;

  useEffect(() => {
    if (props.id > 0) {
      GetStoreCmsWorkingHoursByIdAnonymousService(props.storeId);
    }
  }, []);

  useEffect(() => {
    if (addUpdateCmsWorkingHoursState.success) {
      if (props.id > 0) {
        toast.success(formatMessage("updated_success"));
      } else {
        toast.success(formatMessage("added_success"));
      }
      onModalClosed();
      GetStoreCmsWorkingHoursByIdAnonymousService(props.storeId);
    }
  }, [addUpdateCmsWorkingHoursState.success]);

  /**
   * This function closes the pop up modal .
   */
  const onModalClosed = () => {
    resetAddUpdateCMSWorkingHoursState();
    props.modalClosed();
  };

  /**
   * This function adds the staff when "Id < 0" and updates the Existing staff when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values: any) => {
    if (props.id > 0) {
      UpdateCMSWorkingHoursService(values);
    } else {
      AddCMSWorkingHoursService(values);
    }
  };

  return (
    <React.Fragment>
      <AddWorkingDaysForm
        id={props.id}
        storeId={props.storeId}
        isLoading = {addUpdateCmsWorkingHoursState.inProgress || cmsStoreWorkingHoursState.inProgress}
        initialValues={getWorkingHoursSettingDetail}
        submitHandler={onSubmitForm}
        modalClosed={onModalClosed}
      />
    </React.Fragment>
  );
};

export default observer(AddWorkingDays);
